<template>
  <Dialog
    :visible="visible"
    modal
    dismissable-mask
    :style="{ width: '32rem', maxWidth: 'calc(100vw - 1rem)' }"
    :pt="{ root: { 'aria-labelledby': titleId } }"
    @update:visible="$emit('update:visible', $event)">
    <template #container>
      <div class="flex max-h-[min(640px,calc(100dvh-80px))] min-h-0 flex-col">
        <header class="flex items-start gap-4 border-b border-line px-6 pt-[22px] pb-4">
          <div class="flex min-w-0 flex-1 flex-col gap-1">
            <h2 :id="titleId" class="text-xl/[1.3] font-semibold text-heading">
              Fix {{ validationErrors.length === 1 ? 'this issue' : `${validationErrors.length} issues` }} to publish
            </h2>
            <p class="text-sm/normal text-copy">Nothing has gone live. Your changes are saved as a draft.</p>
          </div>
          <button
            type="button"
            aria-label="Close"
            title="Close"
            class="flex size-8 shrink-0 items-center justify-center rounded-full text-muted hover:bg-overlay hover:text-heading"
            @click="$emit('update:visible', false)">
            <XMarkIcon class="size-[18px]" />
          </button>
        </header>
        <ul
          data-test="publish-errors-list"
          class="m-6 flex min-h-0 flex-col overflow-y-auto rounded-[10px] border border-line bg-[var(--rm-app-card)]">
          <li
            v-for="(error, index) in validationErrors"
            :key="index"
            class="flex items-start gap-2.5 px-4 py-3 text-sm/[1.45] text-heading"
            :class="index > 0 ? 'border-t border-line' : ''">
            <ExclamationCircleIcon class="mt-0.5 size-4 shrink-0 text-danger" aria-hidden="true" />
            <span class="min-w-0 flex-1 break-words">{{ error.message }}</span>
          </li>
        </ul>
        <footer class="flex justify-end border-t border-line px-6 py-3.5">
          <Button size="small" severity="secondary" outlined label="Close" @click="$emit('update:visible', false)" />
        </footer>
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { ExclamationCircleIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import { useId } from 'vue'

defineProps<{
  visible: boolean
  validationErrors: { message: string; references: string[] }[]
}>()
defineEmits<{ (e: 'update:visible', value: boolean): void }>()

const titleId = useId()
</script>
